import React from 'react';
import './Privacy.css';

const Privacy: React.FC = () => {
  return (
    <div className="privacy">
      <div className="container">
        <section className="privacy-header">
          <h1>Adatvédelmi tájékoztató</h1>
          <p>Utolsó frissítés: 2026. február 22.</p>
        </section>

        <section className="privacy-content">
          <div className="privacy-section">
            <h2>1. Bevezetés</h2>
            <p>
              Ez az adatvédelmi tájékoztató leírja, hogyan gyűjtjük, használjuk és 
              védjük az Ön személyes adatait a gyorszobafesto.hu weboldal használata során. 
              A személyes adatok kezelését a GDPR (Általános Adatvédelmi Rendelet) 
              és az releváns magyar jogszabályok szerint végezzük.
            </p>
            <p>
              Adatkezelő: Lakics Márk egyéni vállalkozó<br />
              Székhely: 9073 Bőny, Szabadság út 49.<br />
              Email: info@lakicsfesto.com<br />
              Telefonszám: 0036309869878
            </p>
          </div>

          <div className="privacy-section">
            <h2>2. Kezelt adatok köre</h2>
            <h3>2.1. Kapcsolatfelvétel során gyűjtött adatok</h3>
            <ul>
              <li>Név</li>
              <li>Email cím</li>
              <li>Telefonszám (opcionális)</li>
              <li>Üzenet tartalma</li>
              <li>Szolgáltatás típusa</li>
            </ul>

            <h3>2.2. Technikai adatok</h3>
            <ul>
              <li>IP cím</li>
              <li>Böngésző típusa és verziója</li>
              <li>Operációs rendszer</li>
              <li>Látogatás időpontja</li>
              <li>Látogatott oldalak</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>3. Az adatkezelés célja</h2>
            <ul>
              <li>Kapcsolattartás és ajánlatkérések kezelése</li>
              <li>Szolgáltatások nyújtása</li>
              <li>Weboldal működésének biztosítása</li>
              <li>Statisztikai elemzések készítése</li>
              <li>Biztonság fenntartása</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>4. Az adatkezelés jogalapja</h2>
            <p>
              Az adatkezelés jogalapja az Ön hozzájárulása, amelyet a kapcsolatfelvétel 
              során megadott adataival ad meg. A hozzájárulását bármikor visszavonhatja.
            </p>
          </div>

          <div className="privacy-section">
            <h2>5. Adatfeldolgozók</h2>
            <p>
              Az adatfeldolgozás során az alábbi szolgáltatókat vehetjük igénybe:
            </p>
            <ul>
              <li>Tárhelyszolgáltató: TM Infotech Kft</li>
              <li>Email szolgáltató: TM Infotech Kft</li>
              <li>Webanalitika szolgáltató: TM Infotech Kft</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>6. Adattárolás időtartama</h2>
            <p>
              A kapcsolatfelvétel során megadott személyes adatokat a kapcsolatfelvételtől 
              számított 2 évig tároljuk, kivéve, ha a kapcsolat folyamatos (pl. szerződéses 
              viszony), ebben az esetben a szerződés lejártáig vagy a kapcsolat megszűnéséig.
            </p>
            <p>
              A technikai adatokat a weboldal működéséhez szükséges ideig tároljuk, 
              általában 30 napig.
            </p>
          </div>

          <div className="privacy-section">
            <h2>7. Adatbiztonság</h2>
            <p>
              Megfelelő technikai és szervezési intézkedéseket teszünk annak érdekében, 
              hogy megvédjük az Ön személyes adatait a jogosulatlan hozzáféréstől, 
              módosítástól, továbbítástól, nyilvánosságra hozataltól, törléstől vagy 
      véletlen megsemmisüléstől.
            </p>
            <p>
              Az adatokat titkosított csatornákon keresztül továbbítjuk, és a szervereket 
              megfelelő biztonsági intézkedésekkel védjük.
            </p>
          </div>

          <div className="privacy-section">
            <h2>8. Az Ön jogai</h2>
            <p>
              A GDPR értelmében Önnek joga van:
            </p>
            <ul>
              <li><strong>Tájékoztatáshoz:</strong> Tájékoztatást kérni a kezelt személyes adatairól</li>
              <li><strong>Hozzáféréshez:</strong> Hozzáférni a személyes adataihoz</li>
              <li><strong>Helyesbítéshez:</strong> Kérni a pontatlan adatok helyesbítését</li>
              <li><strong>Törléshez:</strong> Kérni a személyes adatainak törlését</li>
              <li><strong>Korlátozáshoz:</strong> Kérni az adatkezelés korlátozását</li>
              <li><strong>Adathordozhatósághoz:</strong> Kérni az adatok átadását más szolgáltatónak</li>
              <li><strong>Tiltakozáshoz:</strong> Tiltakozni az adatkezelés ellen</li>
              <li><strong>Hozzájárulás visszavonásához:</strong> Visszavonni a hozzájárulását</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>9. Sütik (Cookies)</h2>
            <p>
              A weboldalunk sütiket használhat a működés optimalizálása érdekében. 
              A sütik kis szöveges fájlok, amelyeket a böngészője tárol a számítógépén.
            </p>
            <p>
              A sütik segítségével megjegyezzük a beállításait, és statisztikai adatokat 
              gyűjtünk a weboldal használatáról.
            </p>
          </div>

          <div className="privacy-section">
            <h2>10. Adatvédelmi incidensek</h2>
            <p>
              Adatvédelmi incidens esetén (amikor személyes adatok jogosulatlanul 
              kerülnek feldolgozásra) 72 órán belül értesítjük az érintett felhasználókat 
              és a Nemzeti Adatvédelmi és Információszabadság Hatóságot.
            </p>
          </div>

          <div className="privacy-section">
            <h2>11. Jogorvoslati lehetőségek</h2>
            <p>
              Amennyiben úgy érzi, hogy megsértettük a személyes adatok védelméhez 
              fűződő jogait, kérem, először vegye fel velünk a kapcsolatot az 
              info@lakicsfesto.com email címen.
            </p>
            <p>
              Ha a panaszát nem találja kielégítőnek, jogosult panaszt tenni a 
              Nemzeti Adatvédelmi és Információszabadság Hatóságnál:
            </p>
            <p>
              Nemzeti Adatvédelmi és Információszabadság Hatóság<br />
              Cím: 1055 Budapest, Falk Miksa utca 9-11.<br />
              Postacím: 1363 Budapest, Pf.: 9.<br />
              Email: ugyfelszolgalat@naih.hu<br />
              Web: www.naih.hu
            </p>
          </div>

          <div className="privacy-section">
            <h2>12. A tájékoztató módosítása</h2>
            <p>
              Fenntartjuk a jogot, hogy ezt az adatvédelmi tájékoztatót egyoldalúan 
              módosítsuk. A módosítások a weboldalon való közzététellel lépnek hatályba.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
